import { render, staticRenderFns } from "./ChartjsHorizontalBarChartCreator.vue?vue&type=template&id=2aad1e8c&"
import script from "./ChartjsHorizontalBarChartCreator.vue?vue&type=script&lang=js&"
export * from "./ChartjsHorizontalBarChartCreator.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsHorizontalBarChartCreator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports